type T = (k: string, p?: Record<string, string | number>) => string;

/** Приводит известные сырые ответы backend к языку интерфейса. Незнакомые сообщения возвращаются как есть. */
export function localizeAuthError(message: string, t: T, status?: number, code?: string): string {
  const m = (message || "").toLowerCase();
  if (code === "consent_required") return t("auth.err.consent_required");
  if (status === 429 || m.includes("too many")) return t("auth.err.too_many");
  if (m.includes("invalid email or password") || m.includes("invalid credentials")) return t("auth.err.invalid_credentials");
  if (m.includes("user already exists") || m.includes("email_taken")) return t("auth.err.email_taken");
  if (m.includes("failed to fetch") || m.includes("networkerror") || m.includes("load failed")) return t("auth.err.network");
  return message;
}
